var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ato / camera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ato-/-camera",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1, 0.0893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "meeting-camera",
    transform: "translate(0.75, 5.261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    stroke: "#FFFFFF",
    strokeWidth: 1.5464186,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 0,
    y: 0,
    width: 15,
    height: 13.5,
    rx: 3.0928372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,9.75 L21.415,11.457 C21.6474853,11.573065 21.9234829,11.5605224 22.1444826,11.4238489 C22.3654823,11.2871753 22.5,11.0458471 22.5,10.786 L22.5,2.713 C22.500206,2.45310138 22.3656666,2.21167324 22.1445319,2.07512002 C21.9233972,1.9385668 21.6472802,1.92640985 21.415,2.043 L18,3.75",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 1.5464186,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "#FFFFFF",
    points: "1.36580246 0.739 12.5833395 0.739 14.7962154 1.96340557 14.3327978 11.7875428 12.5833395 13.3705789 2.83606111 13.3705789 0.25 11.7276609 0.25 4.739"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    fill: "#FFFFFF",
    points: "17.5313147 4.30490195 17.5313147 9.739 21.6934109 11.7875428 22.9255185 7.739 21.8985654 2.49078149 18.2340778 3.86926621"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.8de194d3d9300e46094dd8a4c46142d2.svg";
export { ForwardRef as ReactComponent };